var $ecaca51f024191b0$exports = {};
$ecaca51f024191b0$exports = {
    "loading": `Indl\xe6ser ...`,
    "loadingMore": `Indl\xe6ser flere ...`
};


export {$ecaca51f024191b0$exports as default};
//# sourceMappingURL=da-DK.module.js.map
